<div class="main">
    <div class="section">
        <div class="header">
            <div class="label">
                Upload Files
            </div>
            <div class="close">
                <button mat-icon-button class="close-button" [mat-dialog-close]="true">
                    <img src="assets/popup_close_icon.svg" alt="">
                </button>
            </div>
        </div>
        <div class="body">
            <div class="inputRow">
                <!-- <div class="uploadBtn">
                    <div class="btn"></div>
                    <div class="buton" (click)="selectDocs()">
                        {{'SHIPMENTDETAILS.upload' | translate}}
                    </div>
                </div> -->
                <div class="input">
                <input id="epods" #fileUploader multiple accept=".pdf" (change)="fileChanged($event)"
                    type="file" />
                    </div>
            </div>
            <div class="buttons">
                <div class="newButton" (click)="upload()">
                    <div class="label">
                        Upload
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>